var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultiListSelect',{attrs:{"list":_vm.list,"optionValue":_vm.optionValue,"optionText":_vm.optionText,"selected-items":_vm.items,"placeholder":_vm.placeholder},on:{"select":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }